import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageNotifySquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M11.687 17.191v-1a1 1 0 0 0-.707.293zM6.678 22.2h-1a1 1 0 0 0 1.707.707zm0-5.009h1a1 1 0 0 0-1-1zM10.8 4a1 1 0 1 0 0-2v2m11.8 8a1 1 0 1 0-2 0h2m-10.913 5.191-.707-.707-5.009 5.009.707.707.707.707 5.01-5.009zM6.678 22.2h1v-5.009h-2V22.2zm0-5.009v-1H4.8v2h1.878zm-4.278-2.4h1V5.4h-2v9.391zm16.8 2.4v-1h-7.513v2H19.2zM4.8 3v1h6V2h-6zm16.8 9h-1v2.791h2V12zm-2.4 5.191v1a3.4 3.4 0 0 0 3.4-3.4h-2a1.4 1.4 0 0 1-1.4 1.4zM2.4 5.4h1A1.4 1.4 0 0 1 4.8 4V2a3.4 3.4 0 0 0-3.4 3.4zm2.4 11.791v-1a1.4 1.4 0 0 1-1.4-1.4h-2a3.4 3.4 0 0 0 3.4 3.4zM21.6 5.4h-1A2.6 2.6 0 0 1 18 8v2a4.6 4.6 0 0 0 4.6-4.6zM18 9V8a2.6 2.6 0 0 1-2.6-2.6h-2A4.6 4.6 0 0 0 18 10zm-3.6-3.6h1A2.6 2.6 0 0 1 18 2.8v-2a4.6 4.6 0 0 0-4.6 4.6zM18 1.8v1a2.6 2.6 0 0 1 2.6 2.6h2A4.6 4.6 0 0 0 18 .8z"
    />
  </svg>
);
export default SvgMessageNotifySquare;
